/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs */

const en_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invalid event group index. ${i?.index}`)
};

const fr_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Index de groupe d'evenements invalide. ${i?.index}`)
};

const de_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ungültiger Ereignisgruppenindex. ${i?.index}`)
};

const it_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Indice del gruppo di eventi non valido. ${i?.index}`)
};

const ru_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Неверный индекс группы событий. ${i?.index}`)
};

const es_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Índice de grupo de eventos no válido. ${i?.index}`)
};

const zh_cn2_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无效的事件组索引。${i?.index}`)
};

const ja_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`無効なイベント グループ インデックスです。${i?.index}`)
};

const hi_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अमान्य इवेंट समूह सूचकांक। ${i?.index}`)
};

const pt_pt2_iframe_remote_blank_frames_invalid_index_error = /** @type {(inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Índice de grupo de eventos inválido. ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Invalid event group index. {index}" |
*
* @param {Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_blank_frames_invalid_index_error = /** @type {((inputs: Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Blank_Frames_Invalid_Index_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_blank_frames_invalid_index_error(inputs)
	if (locale === "de") return de_iframe_remote_blank_frames_invalid_index_error(inputs)
	if (locale === "it") return it_iframe_remote_blank_frames_invalid_index_error(inputs)
	if (locale === "ru") return ru_iframe_remote_blank_frames_invalid_index_error(inputs)
	if (locale === "es") return es_iframe_remote_blank_frames_invalid_index_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_blank_frames_invalid_index_error(inputs)
	if (locale === "ja") return ja_iframe_remote_blank_frames_invalid_index_error(inputs)
	if (locale === "hi") return hi_iframe_remote_blank_frames_invalid_index_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_blank_frames_invalid_index_error(inputs)
	return en_iframe_remote_blank_frames_invalid_index_error(inputs)
});